import React from 'react'
import Link from '../Link/Link'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { ReactSVG } from 'react-svg'
import { proxySvgUrl } from '@/utils/proxySvgUrl'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import EventSeatIcon from '@material-ui/icons/EventSeat'

const useStyles = makeStyles(() => ({
  reservationsLink: {
    '& svg': {
      height: '1.5rem !important',
      width: '1.5rem !important',
    },
  },
}))

export const ReservationsLink = ({
  className,
  url,
}: {
  className: string
  url?: string
}) => {
  const classes = useStyles()
  const { trackEvent } = useMatomo()
  const { t } = useTranslation()

  return (
    <Tooltip title={t('texts:reservations:header_tooltip')} arrow>
      <Link href={'/my-reservations'}>
        <a
          className={clsx(className, 'reservations-go-to')}
          data-testid={'go_to_reservations'}
          onClick={() =>
            trackEvent({
              category: 'user Reservations',
              action: `User go to his Reservations`,
            })
          }
        >
          {url ? (
            <ReactSVG
              className={classes.reservationsLink}
              src={proxySvgUrl(url)}
            />
          ) : (
            <EventSeatIcon />
          )}
        </a>
      </Link>
    </Tooltip>
  )
}
